module.exports = __webpack_public_path__ + "assets/img/hot-goods-icon.7ed6a6d6.png";